export default __webpack_public_path__ + "static/media/getwotty_logo_test_2.dd052b5c.svg";